module.exports = __webpack_public_path__ + "img/j_2.766aea5f.jpg";